import { ACTION_COSTS, FREE_MONTHLY_CREDITS, PACK_EXPIRY_MONTHS } from "./credits";

// The body of the terms; the Credits clause and the refund policy follow it.
const termsBody = (
  <>
    <p>
      Listino provides research assistance and editable listing-preparation materials for real
      estate professionals. Listing preps may include property facts, candidate comparable
      properties, pricing guidance, marketing copy, photo recommendations, and generated images.
      They are not appraisals, broker price opinions, legal advice, or guarantees of price, timing,
      or other market outcomes.
    </p>
    <p>
      Property and market information can be incomplete, delayed, or wrong. Candidate comparables
      are researched from publicly accessible web sources, not a private MLS feed. You are
      responsible for checking property facts, source details, fair-housing compliance, pricing, and
      other time-sensitive information against authoritative local systems before using a listing
      prep with a client or publishing it.
    </p>
    <p>
      You may edit listing preps and share or export the finished materials with sellers, clients,
      photographers, stagers, brokerage colleagues, and through your own listing-marketing and
      social channels. You may not resell Listino itself, offer unmodified Listino output as a
      competing listing-preparation service, remove ownership/rights notices, or use the service to
      violate law or another person's rights.
    </p>
    <p>
      Owner-created web share links can be forwarded by anyone who receives them. You control when
      to create or revoke those links and should avoid publishing confidential seller information.
      Revocation stops the Listino link from working but cannot recall files or copies already
      downloaded or shared elsewhere.
    </p>
    <ul>
      <li>
        <p>
          Recommendations reflect general practices and the information available at generation
          time; adapt them to the property, client instructions, brokerage policy, and local market.
        </p>
      </li>
      <li>
        <p>
          Listing preps and images may be produced with automated and generative-AI systems. You are
          responsible for human review of AI output and manual edits for accuracy, advertising
          rules, intellectual-property rights, privacy, and fair-housing compliance before use.
        </p>
      </li>
      <li>
        <p>
          To the extent permitted by law, Listino is not liable for market outcomes or losses caused
          by relying on unverified third-party or generated information.
        </p>
      </li>
    </ul>
  </>
);

const n = (/** @type {number} */ v) => v.toLocaleString("en-US");

export const termsAndConditions = (
  <>
    {termsBody}
    <hr />
    <h4 id="credits">Credits</h4>
    <br />
    <p>
      Listino prices the work it prepares in credits (for example, a listing analysis is{" "}
      {n(ACTION_COSTS.analysis)} credits). Credits are a prepaid usage allowance for the Listino
      service. They are not stored value, currency, or property; they have no cash value and cannot
      be transferred, sold, or redeemed for money except as described in the Refund Policy below.
    </p>
    <p>
      Every account receives {n(FREE_MONTHLY_CREDITS)} credits each month on the Free plan at no
      charge. Credits included with a monthly plan are added each billing month and expire at the
      end of that billing month without rolling over. Credits included with an annual plan are added
      as a single pool at the start of the term and expire when the term ends. Credit packs expire{" "}
      {PACK_EXPIRY_MONTHS} months after purchase or, if you hold a plan, at the end of your current
      plan term, whichever comes first.
    </p>
    <p>
      Credits are deducted only when you start something Listino prepares. If a generation fails,
      the credits it used are returned to your balance automatically. Editing, branding, comps
      curation, sharing, and publishing do not use credits. Credit prices and the prices of plans
      and packs may change with notice; a change does not affect credits already in your balance.
    </p>
    <hr />
    <h4 id="refund-policy">Refund Policy</h4>
    <br />
    <p>
      You may request a full refund of any plan or credit-pack purchase within 7 days of that
      purchase by contacting <a href="mailto:help@listino.ai">help@listino.ai</a>. When a purchase
      is refunded, only the unspent credits from that purchase are removed from your balance;
      credits you have already used are not charged back and your balance never goes below zero.
      Requests after 7 days are considered case by case.
    </p>
  </>
);
